import { render, staticRenderFns } from "./SkeletonEmptyList.vue?vue&type=template&id=16c17600&scoped=true&"
import script from "./SkeletonEmptyList.vue?vue&type=script&lang=js&"
export * from "./SkeletonEmptyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c17600",
  null
  
)

export default component.exports